import { AbstractControl, ValidatorFn } from '@angular/forms';

export function domain(): ValidatorFn {
    const nameRe: RegExp = new RegExp(
        /^(?:http(s)?:\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,11}?$/
    );

    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { domain: true }) || null;
}

export function alias(): ValidatorFn {
    const nameRe: RegExp = /^(?!-)(?!.*--)[a-z0-9-]{3,50}(?<!-)$/;

    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;

        if (!value) {
            return null; // No validar si está vacío, eso es trabajo de 'required'
        }

        const isValid = nameRe.test(value) && !value.includes('.');

        return isValid ? null : { domain: true };
    };
}
